import React, { useEffect, useRef, useState } from "react";
import { areas } from "../../helpers/areas";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  makeStyles,
  MenuItem,
  FormControl,
  Grid,
  TextField,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  ValidatorForm,
  TextValidator,
  SelectValidator,
} from "react-material-ui-form-validator";
import { CboLocalidades } from "../cbos/CboLocalidades";
import { CboProvincias } from "../cbos/CboProvincias";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";
import { CboNacionalidades } from "../cbos/CboNacionalidades";
import {
  guardarFamiliarAfiliadoNuevo,
  guardarFamiliarNuevo,
  guardarFamiliarStageFamiliarNuevo,
} from "../../actions/preAfiliado/afiliado";
import { CboParentescosG } from "../cbos/CboParentescoG";
import { useForm } from "../../hooks/useForm";
import AutorenewOutlinedIcon from "@material-ui/icons/AutorenewOutlined";
import { getCuilCuit, getCuilCuitRN } from "../../helpers/CUILgenerator";
import { fetchConToken } from "../../helpers/fetch";
import {
  PARENTESCOS,
  TIPO_DOCUMENTO,
  SEXO,
  ESTADOS_CIVILES,
} from "../../utils/constants";
import { startAlerta } from "../../actions/ui/alertas";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

export const FormularioFamiliar = (props) => {
  moment.locale("es");
  const dispatch = useDispatch();
  const classes = useStyles();

  const { afiliadoEncontrado } = useSelector((state) => state.preinscripto);
  const { afiliado, consultaAfiliado } = useSelector(
    (state) => state.afiliacion
  );
  const { familiarSeleccionado, familiarStagePreafiliadoSeleccionado } =
    useSelector((state) => state.familiarSeleccionado);
  const { items: localidades } = useSelector((state) => state.localidades);
  const { idArea: idAreaUsuario } = useSelector((state) => state.auth.areas[0]);
  const { items: grupoFamiliar } = useSelector((state) => props.idGrupo === "idGrupoFamiliarPreinscripto" ? state.grupofamiliarPreinscripto : state.grupofamiliar);
  const { items: grupoFamiliarParentesco } = useSelector((state) => state.grupofamiliar)
  const [hayErrorCuilFamiliar, setHayErrorCuilFamiliar] = useState("");
  let arrayFinal = [];
  arrayFinal = grupoFamiliarParentesco.concat(grupoFamiliar);
  // eslint-disable-next-line
  const [validarNroDoc, setNroDoc] = React.useState(false);
  // eslint-disable-next-line
  const [validarNroDoc2, setNroDoc2] = React.useState(false);
  const [errorFechaNacimiento, setErrorFechaNacimiento] = React.useState(false);
  // const errorFechaNacimiento = false;
  const [familiar /* , setFamiliar */] = React.useState({
    apellido_y_nombre: "",
    id_usuario_alta: 0,
    parent: "",
    fecha_nacimiento: null,
    fecha_fin_cobertura: null,
    cuil: "",
    id_parentesco: 0,
    sexo: "",
    nro_doc: "",
    id_tipo_documento: 0,
    id_estado_civil: 0,
    id_nacionalidad: 0,
    id_plan: afiliadoEncontrado?.id_plan || afiliado?.id_plan,
    id_tipo_afiliacion: afiliadoEncontrado?.id_tipo_afiliacion || null,
    incapacitado: 0, // PREGUNTAR
    idGrupoFamiliar:
      afiliadoEncontrado?.idGrupoFamiliar || afiliado?.idGrupoFamiliar,
    cuil_familiaracargo: "",
    domiciliosAfiliados: {
      calle: afiliadoEncontrado?.domiciliosAfiliados.calle || "",
      nro: afiliadoEncontrado?.domiciliosAfiliados.nro || "",
      piso: afiliadoEncontrado?.domiciliosAfiliados.piso || "",
      dpto: afiliadoEncontrado?.domiciliosAfiliados.dpto || "",
      torre: afiliadoEncontrado?.domiciliosAfiliados.torre || "",
      circ: afiliadoEncontrado?.domiciliosAfiliados.circ || "",
      telefono: afiliadoEncontrado?.domiciliosAfiliados.telefono || "",
      celular: afiliadoEncontrado?.domiciliosAfiliados.celular || "",
      codigo_postal:
        afiliadoEncontrado?.domiciliosAfiliados.codigo_postal || "",
      mail: afiliadoEncontrado?.domiciliosAfiliados.mail || "",
      manzana: "",
      id_localidad: afiliadoEncontrado?.domiciliosAfiliados.id_localidad,
      id_provincia: afiliadoEncontrado?.domiciliosAfiliados.id_provincia,
      id_seccional: afiliadoEncontrado?.domiciliosAfiliados.id_seccional,
      id_afiliado: afiliadoEncontrado?.id_afiliado || afiliado?.id_afiliado,
    },
  });

  const getInitForm = () => {
    if (Object.keys(familiarSeleccionado).length > 0) {
      return familiarSeleccionado;
    }
    if (Object.keys(familiarStagePreafiliadoSeleccionado).length > 0) {
      return familiarStagePreafiliadoSeleccionado;
    }
    return familiar;
  };

  const [
    formValues,
    handleInputChange,
    reset,
    setearValor,
    ,
    setearValorDomicilio,
    setearValorDomicilio2,
    setearValorDomicilio3,
    setearVariosValores,
  ] = useForm(getInitForm());

  const {
    apellido_y_nombre,
    fecha_nacimiento,
    fecha_fin_cobertura,
    cuil,
    id_parentesco,
    sexo,
    nro_doc,
    id_tipo_documento,
    id_estado_civil,
    id_nacionalidad,
    incapacitado,
    cuil_familiaracargo,
    domiciliosAfiliados: {
      calle,
      nro,
      piso,
      dpto,
      torre,
      circ,
      telefono,
      celular,
      codigo_postal,
      mail,
      // manzana,
      id_localidad,
      id_provincia,
    },
    // id_plan
  } = formValues;
  const activeId = useRef(familiarSeleccionado?.id_afiliado);

  const handleInputDomicilio = (e) => {
    setearValorDomicilio(e.target.name, e.target.value);
  };

  // const handleDateChange = (date) => {
  //   if (id_tipo_documento === TIPO_DOCUMENTO.RN) {
  //     setearVariosValores({
  //       fecha_nacimiento: date,
  //       fecha_fin_cobertura: moment(date).add(1, "M"),
  //     });
  //   } else {
  //     setearValor("fecha_nacimiento", date);
  //   }
  // };

  const handleDateChange = (date) => {
    if (id_tipo_documento === TIPO_DOCUMENTO.RN) {
      setearVariosValores({
        fecha_nacimiento: date,
        fecha_fin_cobertura: moment(date).add(1, "M"),
      });
    } else {
      setearValor("fecha_nacimiento", date);
    }
  };

  const handleSubmit = () => {
    if (!errorFechaNacimiento) {
      setearValor("idGrupoFamiliar", afiliadoEncontrado?.idGrupoFamiliar);
      if (Object.keys(consultaAfiliado).length !== 0) {
        console.log("entro por aca 1");
        //STAGE
        dispatch(guardarFamiliarStageFamiliarNuevo(formValues));
      }
      if (Object.keys(afiliado).length !== 0) {
        //CUANDO CONSULTAS UN AFILIADO DESDE CONSULTA O MODIFICACION
        dispatch(guardarFamiliarAfiliadoNuevo(formValues));
      }
      if (Object.keys(afiliadoEncontrado).length !== 0) {
        //CREAR EL BENEFICIARIO
        dispatch(guardarFamiliarNuevo(formValues));
      }
      props.setValue(1);
    }
    else {
      dispatch(startAlerta("Debe corregir la fecha de nacimiento.", "error"))
    }

  };

  const handleCuilGenerator = () => {
    let CUILgenerado;

    if (id_tipo_documento === TIPO_DOCUMENTO.RN) {
      const cantRecienNacidos = grupoFamiliar.filter(
        (familiar) => familiar.id_tipo_documento === TIPO_DOCUMENTO.RN
      ).length;

      CUILgenerado = getCuilCuitRN(nro_doc, cantRecienNacidos);
    } else {
      if (nro_doc && sexo && id_tipo_documento) {
        let sexoAux = sexo === 1 ? "M" : "F";

        CUILgenerado = getCuilCuit(nro_doc, sexoAux);
      } else {
        dispatch(
          startAlerta(
            `Debe completar número documento, sexo y tipo documento para poder generar el Cuil`,
            "error",
            "Error"
          )
        );
      }
    }
    setearValor("cuil", CUILgenerado);
  };

  const handleLocalidadChange = (e) => {
    if (localidades?.length > 0) {
      const localidad = localidades.find(
        (loc) => parseInt(loc?.id_localidad) === parseInt(e.target.value)
      );
      setearValorDomicilio2(
        "id_provincia",
        localidad.id_provincia,
        "id_localidad",
        localidad.id_localidad,
        "id_seccional",
        localidad.id_seccional
      );
    }
  };

  const handleChangeValid = (e) => {
    if (e.target.value === TIPO_DOCUMENTO.RN) {
      setearVariosValores({
        fecha_fin_cobertura: moment(fecha_nacimiento).add(1, "M"),
        id_tipo_documento: e.target.value,
        nro_doc: arrayFinal.find(
          (familiar) => familiar.id_parentesco === PARENTESCOS.TITULAR
        ).nro_doc,
      });
    } else {
      setearVariosValores({
        "fecha_fin_cobertura": null,
        "id_tipo_documento": e.target.value,
        "nro_doc": "",
        "cuil": "",
      });
    }
  };

  const cargarDomicilio = async () => {
    if (afiliado?.id_parentesco === PARENTESCOS.TITULAR) {
      setearValorDomicilio3(
        "calle",
        afiliado.domiciliosAfiliados.calle,
        "nro",
        afiliado.domiciliosAfiliados.nro,
        "telefono",
        afiliado.domiciliosAfiliados.telefono,
        "codigo_postal",
        afiliado.domiciliosAfiliados.codigo_postal,
        "id_localidad",
        afiliado.domiciliosAfiliados.id_localidad,
        "id_provincia",
        afiliado.domiciliosAfiliados.id_provincia,
        "id_seccional",
        afiliado.domiciliosAfiliados.id_seccional,
        "celular",
        afiliado.domiciliosAfiliados.celular,
        "piso",
        afiliado.domiciliosAfiliados.piso,
        "dpto",
        afiliado.domiciliosAfiliados.dpto
      );
      // setearValorDomicilio('mail', afiliado.domiciliosAfiliados.mail)
    } else {
      const response = await fetchConToken(
        `afiliados/traerAfiliadoPorIdGrupoFamiliar/${afiliado.idGrupoFamiliar}`
      );
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const titular = await response.json();
          setearValorDomicilio3(
            "calle",
            titular.domiciliosAfiliados.calle,
            "nro",
            titular.domiciliosAfiliados.nro,
            "telefono",
            titular.domiciliosAfiliados.telefono,
            "codigo_postal",
            titular.domiciliosAfiliados.codigo_postal,
            "id_localidad",
            titular.domiciliosAfiliados.id_localidad,
            "id_provincia",
            titular.domiciliosAfiliados.id_provincia,
            "id_seccional",
            titular.domiciliosAfiliados.id_seccional,
            "celular",
            titular.domiciliosAfiliados.celular,
            "piso",
            titular.domiciliosAfiliados.piso,
            "dpto",
            titular.domiciliosAfiliados.dpto
          );
          // setearValorDomicilio('mail', titular.domiciliosAfiliados.mail)
        }
      }
    }
  };

  useEffect(() => {
    if (
      familiarSeleccionado &&
      familiarSeleccionado.id_afiliado !== activeId.current
    ) {
      reset(
        Object.keys(familiarSeleccionado).length === 0
          ? familiar
          : familiarSeleccionado
      );
      activeId.current = familiarSeleccionado.id_afiliado;
    }
  }, [familiarSeleccionado, reset, familiar]);



  const onChangeCuilFamiliarHandler = (event) => {
    const cuilFamiliarACargo = parseInt(event.target.value);

    const cuilTitular = grupoFamiliar.find(
      (familiar) => familiar.id_parentesco === PARENTESCOS.TITULAR
    ).cuil;
    const hayConyugue = arrayFinal.find(
      (familiar) => familiar.id_parentesco === PARENTESCOS.CONYUGE && familiar.fecha_baja === null
    );
    const hayConcubino = arrayFinal.find(
      (familiar) => familiar.id_parentesco === PARENTESCOS.CONCUBINA_O && familiar.fecha_baja === null
    );
    //
    const esHijoConyugue =
      id_parentesco === PARENTESCOS.HIJO_CONYUGE ||
      id_parentesco === PARENTESCOS.HIJO_CONYUGE_ESTUDIANTE;

    if (cuilFamiliarACargo === cuilTitular) {
      setHayErrorCuilFamiliar(
        "El cuil no puede ser el mismo que el del titular"
      );
    } else if (cuilFamiliarACargo === cuil) {
      setHayErrorCuilFamiliar(
        "El cuil del familiar a cargo no puede ser el mismo cuil que el afiliado"
      );
    } else if (
      esHijoConyugue &&
      !hayConyugue &&
      !hayConcubino &&
      event.target.value.length > 0
    ) {
      setHayErrorCuilFamiliar(
        "No se puede cargar el cuil del familiar a cargo sin un cónyugue/concubino"
      );
    } else {
      setHayErrorCuilFamiliar("");
    }
  };

  useEffect(() => {
    debugger;
    if (
      id_parentesco === PARENTESCOS.HIJO_MENOR ||
      id_parentesco === PARENTESCOS.MENOR_BAJO_GUARDA_O_TUTELA ||
      id_parentesco === PARENTESCOS.HIJO_CONYUGE
    ) {
      const minDate = moment().subtract(21, "years");
      const maxDate = moment(); 

      const nacimientoMoment = moment(fecha_nacimiento);

      const fechaValida =
        nacimientoMoment.isValid() &&
        nacimientoMoment.isBetween(minDate, maxDate, undefined, '[]'); // '[]' incluye límites

      if (!fechaValida) {
        setearValor("fecha_nacimiento", null);
        setErrorFechaNacimiento(true);
        return;
      } else {
        setearValor("fecha_nacimiento", fecha_nacimiento);
        setErrorFechaNacimiento(false);
      }
    }
  }, [
    id_parentesco,
    fecha_nacimiento,
    familiarSeleccionado,
    familiarStagePreafiliadoSeleccionado,
    errorFechaNacimiento
  ]);




  return (
    <div className={classes.root}>
      <ValidatorForm onSubmit={handleSubmit}>
        <DialogTitle id="form-dialog-title" component="span">
          Ingresa Familiar
        </DialogTitle>
        <DialogContent>
          {Object.keys(afiliado).length !== 0 && (
            <Button color="primary" onClick={cargarDomicilio}>
              Repetir Titular
            </Button>
          )}

          <Grid container spacing={3} alignItems="center">
            <Grid item xs={2}>
              <CboParentescosG
                manejadorInputChange={handleInputChange}
                valor={id_parentesco}
                name="id_parentesco"
                grupoFamiliar={arrayFinal}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                margin="normal"
                fullWidth
                inputProps={{ style: { textTransform: "uppercase" } }}
                name="apellido_y_nombre"
                label="Apellido y Nombre"
                value={apellido_y_nombre}
                disabled={idAreaUsuario === areas.Nacional}
                autoComplete="off"
                onChange={handleInputChange}
                validators={["required"]}
                errorMessages={["Este campo es obligatorio"]}
              />
            </Grid>
            <Grid item xs={1}>
              <FormControl margin="normal" fullWidth={true}>
                <SelectValidator
                  value={sexo}
                  disabled={
                    props.idPanel === "idTabConsulta" ||
                      idAreaUsuario === areas.Nacional
                      ? true
                      : false
                  }
                  label="Sexo"
                  name="sexo"
                  validators={["required"]}
                  errorMessages={["El sexo es requerido"]}
                  fullWidth={true}
                  onChange={(e) => {
                    if (e.target.value === SEXO.NO_INFORMADO) dispatch(startAlerta("El sexo NO INFORMADO no se encuentra permitido", "error", "Error"))
                    else setearValor("sexo", e.target.value)
                  }
                  }
                >
                  <MenuItem value="">
                    <em>Seleccione</em>
                  </MenuItem>
                  <MenuItem value={SEXO.MASCULINO}>M</MenuItem>
                  <MenuItem value={SEXO.FEMENINO}>F</MenuItem>
                  <MenuItem value={SEXO.NO_INFORMADO}>N</MenuItem>
                  <MenuItem value={SEXO.NO_BINARIO}>X</MenuItem>
                </SelectValidator>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="dialogFecha_nacimiento"
                  label="Fec. Nac."
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  required={true}
                  disabled={idAreaUsuario === areas.Nacional}
                  name="fecha_nacimiento"
                  maxDate={new Date()} //maxDate
                  minDate={
                    id_parentesco === PARENTESCOS.HIJO_MENOR
                      ? moment().subtract("year", 21)
                      : moment().subtract("year", 200)
                  }
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={
                    moment(fecha_nacimiento).isValid()
                      ? moment(fecha_nacimiento)
                      : null
                  }
                  onChange={(date) => {
                    handleDateChange(date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  error={errorFechaNacimiento} // Mostrar error si está configurado
                  helperText={errorFechaNacimiento ? "La fecha no es válida o está fuera del rango permitido" : ""}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={1}>
              <FormControl margin="normal" fullWidth={true}>
                <SelectValidator
                  fullWidth={true}
                  value={id_tipo_documento || ""}
                  disabled={
                    props.idPanel === "idTabConsulta" ||
                      idAreaUsuario === areas.Nacional
                      ? true
                      : false
                  }
                  label="Tip.Doc"
                  name="id_tipo_documento"
                  validators={["required"]}
                  errorMessages={["Este campo es obligatorio"]}
                  onChange={(e) => {
                    handleChangeValid(e);
                  }}
                >
                  <MenuItem value="">
                    <em>Seleccione</em>
                  </MenuItem>
                  <MenuItem value={TIPO_DOCUMENTO.DNI}>DNI</MenuItem>
                  <MenuItem value={TIPO_DOCUMENTO.LIBRETA_ENROLAMIENTO}>
                    LE
                  </MenuItem>
                  <MenuItem value={TIPO_DOCUMENTO.LIBRETA_CIVICA}>LC</MenuItem>
                  <MenuItem value={TIPO_DOCUMENTO.PASAPORTE}>PAS</MenuItem>
                  <MenuItem value={TIPO_DOCUMENTO.NI}>NI</MenuItem>
                  <MenuItem value={TIPO_DOCUMENTO.RN}>RN</MenuItem>
                </SelectValidator>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                autoFocus
                margin="normal"
                error={validarNroDoc || validarNroDoc2}
                id="name"
                value={nro_doc}
                disabled={idAreaUsuario === areas.Nacional}
                name="nro_doc"
                label="Nro. Doc."
                type="text"
                fullWidth
                autoComplete="off"
                //onBlur={() => {validateDni(nro_doc);}}
                onChange={handleInputChange}
                helperText={
                  (validarNroDoc && "El nro se encuentra en padron") ||
                  (validarNroDoc2 &&
                    "No puede ingresar un familiar con el mismo nro de documento")
                }
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:99999999",
                  "minNumber:999999",
                ]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "solo numeros",
                  "Verifique su dni",
                  "Verifique su dni",
                ]}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={2}>
              <TextValidator
                value={cuil}
                disabled={false}
                autoFocus
                margin="normal"
                id="name"
                name="cuil"
                label="Cuil"
                type="text"
                autoComplete="off"
                fullWidth
                onChange={handleInputChange}
                InputProps={{
                  maxLength: 11,
                  endAdornment: (
                    <InputAdornment>
                      <IconButton onClick={handleCuilGenerator}>
                        <AutorenewOutlinedIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:99999999999",
                  "minNumber:9999999999",
                ]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "solo numeros",
                  "Verifique su cuil",
                  "Verifique su cuil",
                ]}
              />
            </Grid>
            <Grid item xs={2}>
              <CboNacionalidades
                manejadorInputChange={handleInputChange}
                disabled={idAreaUsuario === areas.Nacional}
                valor={id_nacionalidad}
                idPanel={props.idPanel}
                fromBandejaFamiliar={true}
              />
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                autoFocus
                value={mail}
                disabled={idAreaUsuario === areas.Nacional}
                margin="normal"
                id="name"
                name="mail"
                label="Mail"
                autoComplete="off"
                //type="text"
                fullWidth
                onChange={handleInputDomicilio}
                validators={["required", "isEmail"]}
                errorMessages={["Este campo es obligatorio", "Mail invalido"]}
              />
            </Grid>
            <Grid item xs={3}>
              <TextValidator
                value={telefono}
                disabled={idAreaUsuario === areas.Nacional}
                autoFocus
                margin="normal"
                id="name"
                name="telefono"
                label="Telefono (10 digitos sin 0)"
                autoComplete="off"
                type="text"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{"0"}</InputAdornment>
                  ),
                }}
                maxLength="10"
                onChange={handleInputDomicilio}
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:9999999999",
                  "minNumber:999999999",
                ]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "Solo numeros",
                  "Verifique su telefono",
                  "Verifique su telefono",
                ]}
              />
            </Grid>
            <Grid item xs={3}>
              <TextValidator
                autoFocus
                margin="normal"
                id="celular"
                name="celular"
                maxLength="10"
                label="Celular (10 digitos sin 0 ni 15)"
                autoComplete="off"
                type="text"
                fullWidth
                onChange={handleInputDomicilio}
                value={celular}
                disabled={idAreaUsuario === areas.Nacional}
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:9999999999",
                  "minNumber:999999999",
                ]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "Solo numeros",
                  "Verifique su celular",
                  "Verifique su celular",
                ]}
              />
            </Grid>
          </Grid>

          <Grid container spacing={3} alignItems="center">
            <Grid item xs={2}>
              <FormControl margin="normal" fullWidth={true}>
                <SelectValidator
                  value={id_estado_civil}
                  disabled={
                    props.idPanel === "idTabConsulta" ||
                      idAreaUsuario === areas.Nacional
                      ? true
                      : false
                  }
                  label="Est.Civil"
                  name="id_estado_civil"
                  validators={["required"]}
                  errorMessages={["El estado requerido"]}
                  fullWidth={true}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">
                    <em>Seleccione</em>
                  </MenuItem>
                  <MenuItem value={ESTADOS_CIVILES.CASADO}>CASADO/A</MenuItem>
                  <MenuItem value={ESTADOS_CIVILES.SOLTERO}>SOLTERO/A</MenuItem>
                  <MenuItem value={ESTADOS_CIVILES.SEPARADO}>
                    SEPARADO/A
                  </MenuItem>
                  <MenuItem value={ESTADOS_CIVILES.DIVORCIADO}>
                    DIVORCIADO/A
                  </MenuItem>
                  <MenuItem value={ESTADOS_CIVILES.VIUDO}>VIUDO/A</MenuItem>
                  <MenuItem value={ESTADOS_CIVILES.CONCUBINO}>
                    CONCUBINO/A
                  </MenuItem>
                  <MenuItem value={ESTADOS_CIVILES.OTRO}>OTRO</MenuItem>
                </SelectValidator>
              </FormControl>
            </Grid>

            <Grid item xs={3}>
              <TextValidator
                margin="normal"
                value={calle || ""}
                disabled={idAreaUsuario === areas.Nacional}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Calle"
                name="calle"
                onChange={(e) => {
                  handleInputDomicilio(e);
                }}
                autoComplete="off"
                fullWidth
                validators={["required"]}
                errorMessages={["Requerido"]}
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={nro || ""}
                disabled={idAreaUsuario === areas.Nacional}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Numero"
                name="nro"
                onChange={(e) => {
                  handleInputDomicilio(e);
                }}
                //required={true}
                autoComplete="off"
                fullWidth
                validators={["required"]}
                errorMessages={["Requerido"]}
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={piso || ""}
                disabled={idAreaUsuario === areas.Nacional}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Piso"
                name="piso"
                onChange={(e) => {
                  handleInputDomicilio(e);
                }}
                //required={true}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={dpto || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Depto."
                name="dpto"
                disabled={
                  props.idPanel === "idTabConsulta" ||
                    idAreaUsuario === areas.Nacional
                    ? true
                    : false
                }
                onChange={(e) => {
                  handleInputDomicilio(e);
                }}
                //required={true}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={torre || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Torre"
                name="torre"
                disabled={
                  props.idPanel === "idTabConsulta" ||
                    idAreaUsuario === areas.Nacional
                    ? true
                    : false
                }
                onChange={(e) => {
                  handleInputDomicilio(e);
                }}
                //required={true}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={circ || ""}
                disabled={idAreaUsuario === areas.Nacional}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Circ"
                name="circ"
                onChange={(e) => {
                  handleInputDomicilio(e);
                }}
                //required={true}
                autoComplete="off"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={1}>
              <TextValidator
                value={codigo_postal}
                disabled={idAreaUsuario === areas.Nacional}
                autoFocus
                margin="normal"
                id="name"
                name="codigo_postal"
                label="C.P"
                type="text"
                fullWidth
                onChange={(e) => {
                  handleInputDomicilio(e);
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <CboLocalidades
                manejadorInputChange={(e) => {
                  handleInputDomicilio(e);
                  handleLocalidadChange(e);
                }}
                fromBandejaFamiliar={true}
                name="id_localidad"
                disabled={idAreaUsuario === areas.Nacional}
                valor={id_localidad}
                cp={codigo_postal}
                idPanel={""}
              />
            </Grid>
            <Grid item xs={2}>
              <CboProvincias
                valor={id_provincia}
                name="id_provincia"
                manejadorInputChange={(e) => {
                  handleInputDomicilio(e);
                }}
                idPanel={"idTabConsulta"}
              />
            </Grid>
            <Grid item xs={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="dialogFecFin"
                  label="Fecha Fin Cobertura"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={
                    props.idPanel === "idTabConsulta" ||
                      idAreaUsuario === areas.Nacional
                      ? true
                      : false
                  }
                  value={
                    moment(fecha_fin_cobertura).isValid()
                      ? moment(fecha_fin_cobertura)
                      : null
                  }
                  onChange={(date) => {
                    setearValor("fecha_fin_cobertura", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={2}>
              <FormControl margin="normal" fullWidth={true}>
                <SelectValidator
                  value={incapacitado}
                  disabled={idAreaUsuario === areas.Nacional}
                  name="incapacitado"
                  onChange={handleInputChange}
                  label="Discap."
                  validators={["required"]}
                  errorMessages={["Este campo es obligatorio"]}
                >
                  <MenuItem value="">
                    <em>Seleccione</em>
                  </MenuItem>
                  <MenuItem value={0}>NO</MenuItem>
                  <MenuItem value={1}>SI</MenuItem>
                </SelectValidator>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container>
            {(id_parentesco === PARENTESCOS.FAMILIAR_A_CARGO ||
              id_parentesco === PARENTESCOS.HIJO_CONYUGE ||
              id_parentesco === PARENTESCOS.HIJO_CONYUGE_ESTUDIANTE || id_parentesco === PARENTESCOS.MENOR_BAJO_GUARDA_O_TUTELA) && (
                <Grid item xs={2}>
                  <TextValidator
                    margin="normal"
                    fullWidth
                    label="CUIL Familiar a cargo"
                    name="cuil_familiaracargo"
                    value={cuil_familiaracargo || ""}
                    autoComplete="off"
                    required={false}
                    error={
                      hayErrorCuilFamiliar && hayErrorCuilFamiliar.length > 0
                    }
                    helperText={hayErrorCuilFamiliar}
                    disabled={
                      props.idPanel === "idTabConsulta" ||
                        idAreaUsuario === areas.Nacional
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      handleInputChange(e);
                      onChangeCuilFamiliarHandler(e);
                    }}
                    validators={[
                      // "required",
                      "isNumber",
                      "maxNumber:99999999999",
                      "minNumber:9999999999",
                    ]}
                    errorMessages={[
                      // "Este campo es obligatorio",
                      "solo numeros",
                      "Verifique el cuil",
                      "Verifique el cuil",
                    ]}
                  />
                </Grid>
              )}
          </Grid>
          <DialogActions>
            <Button onClick={props.handleClose} color="primary">
              {idAreaUsuario === areas.Nacional ? "Cerrar" : "Cancelar"}
            </Button>
            {idAreaUsuario === areas.Seccional && (
              <Button type="submit" color="primary">
                Aceptar
              </Button>
            )}
          </DialogActions>
        </DialogContent>
      </ValidatorForm>
    </div>
  );
};
